import actions from './constants';

export const fetchDatasetLinks = (category, code) => ({
  type: actions.FETCH_DATASET_LINKS,
  category,
  code,
});

export const fetchDatasetLinksSuccess = (category, code, result) => ({
  type: actions.FETCH_DATASET_LINKS_SUCCESS,
  category,
  code,
  result,
});

export const fetchDatasetLinksError = (category, code, error) => ({
  type: actions.FETCH_DATASET_LINKS_ERROR,
  category,
  code,
  error,
});
